// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"100%\" width=\"100% fill=\"currentColor\" viewBox=\"0 0 20 21\"><path stroke=\"#475467\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M5 10.27h10m-12.5-5h15m-10 10h5\"/></svg>";
// Exports
module.exports = code;